module.exports = __webpack_public_path__ + "img/637025866231927864Zelfbeeld.png";